'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var text = require('./text.js');
var themeGet = require('../utils/themeGet.js');
var isEmpty = require('../utils/lodashUtils/isEmpty.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: #F6F7F8 !important;\n  padding: 20px;\n  height: 48px;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  min-width: 10%;\n  \n  &.data {\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 18px;\n    font-weight: 400;\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  border-top: none;\n  \n  &:first-child {\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n  &:last-child {\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n  }\n\n\n  &:nth-of-type(even) {\n    background-color: #FAFAFA;\n  }\n\n  ", "\n\n  .thead {\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n    letter-spacing: 0.02em;\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Row = styled__default['default'].div(_templateObject(), index.styleEngine, themeGet['default']('colors.grey.08'));
var Column = styled__default['default'](text['default'])(_templateObject2(), function (props) {
  return props.clickable && "\n    &:hover {\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  ";
}, index.styleEngine, themeGet['default']('colors.grey.12'));
var ColumnRow = styled__default['default'](Row)(_templateObject3(), index.styleEngine);

var Table = function Table(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder,
      alternateColors = _ref.alternateColors,
      dataRowProps = _ref.dataRowProps,
      columnRowProps = _ref.columnRowProps;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ColumnRow, columnRowProps, columns.map(function (_ref2, index) {
    var name = _ref2.name,
        renderHead = _ref2.renderHead,
        rest = _objectWithoutProperties(_ref2, ["name", "renderHead"]);

    return /*#__PURE__*/React__default['default'].createElement(text['default'], _extends({
      key: index
    }, rest, {
      className: "thead"
    }), renderHead ? renderHead() : name);
  })), data.map(function (datum, index) {
    return /*#__PURE__*/React__default['default'].createElement(Row, _extends({}, dataRowProps, {
      background: !isEmpty['default'](alternateColors) ? index % 2 === 0 ? alternateColors.color1 : alternateColors.color2 : null,
      hasBorder: hasBorder,
      key: index
    }, datum.rowProps || {}), columns.map(function (_ref3) {
      var key = _ref3.key,
          render = _ref3.render,
          _onClick = _ref3.onClick,
          opacity = _ref3.opacity,
          rest = _objectWithoutProperties(_ref3, ["key", "render", "onClick", "opacity"]);

      return /*#__PURE__*/React__default['default'].createElement(Column, _extends({
        key: index
      }, rest, datum.dataProps || {}, {
        opacity: opacity ? opacity : datum.disable ? 0.4 : 1,
        clickable: typeof _onClick === 'function',
        onClick: function onClick() {
          return _onClick && _onClick(datum, index);
        },
        className: "data"
      }), render ? render(datum, index) : datum[key]);
    }));
  }));
};
Table.propTypes = {
  columns: PropTypes__default['default'].array,
  data: PropTypes__default['default'].array,
  name: PropTypes__default['default'].string,
  onBack: PropTypes__default['default'].func,
  hasBorder: PropTypes__default['default'].bool,
  alternateColors: PropTypes__default['default'].object,
  dataRowProps: PropTypes__default['default'].object,
  columnRowProps: PropTypes__default['default'].object,
  restProps: PropTypes__default['default'].object
};

exports.default = Table;
